module.exports = __webpack_public_path__ + "img/BillsIcon.b2e52ea9.png";